export default "__VITE_ASSET__Bsy5wCd$__"